if (!customElements.get('image-with-tabs')) {
  class ImageWithtabs extends HTMLElement {
    constructor() {
      super();

      this.sliderElement = this.querySelector('.image-with-tabs__slider');
      this.tabButtons = this.querySelectorAll('.image-with-tabs__tab');

      
      this.initStyle();
      this.initSlider();
      this.initTabs();
      this.initOutsideClickHandler();
    }

    initStyle() {
      let _this = this;
      this.tabButtons.forEach(function(tab) {
        if(tab.classList.contains('is-selected')) {
          _this.style.setProperty("--current-tab-text-color", tab.dataset.tabTextColor);
          _this.style.setProperty("--current-tab-bg-color", tab.dataset.tabBackgroundColor);
        }
      })
    }

    initSlider() {
      let _this = this;
      this.flicktySlider = new Flickity(this.sliderElement, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });

      this.flicktySlider.on('change', function(index) {
        _this.handleNewStyle(index);
      })
    }

    initTabs() {
      let _this = this;
      this.tabButtons.forEach(function(tab) {
        tab.addEventListener('click', function() {

          // Prevent this click from triggering the document click handler
          event.stopPropagation();

          // Remove focused class from all tabs first
          _this.tabButtons.forEach(t => t.classList.remove('is-focused'));
          
          // Add focused class to clicked tab
          tab.classList.add('is-focused');
          _this.handleTabSwitch(tab);
        });
      })
    }

       initOutsideClickHandler() {
      let _this = this;
      // Add a click event listener to the document
      document.addEventListener('click', function(event) {
        // Check if the click was outside the tabs
        let clickedInside = false;
        _this.tabButtons.forEach(function(tab) {
          if (tab.contains(event.target)) {
            clickedInside = true;
          }
        });
        
        // If clicked outside, remove the is-focused class from all tabs
        if (!clickedInside) {
          _this.tabButtons.forEach(function(tab) {
            tab.classList.remove('is-focused');
          });
        }
      });
    }

    handleTabSwitch(tab) {
      console.log(tab);

      this.tabButtons.forEach((tab) => tab.classList.remove('is-selected'));
      tab.classList.add('is-selected');

      //Current index
      let currentIndex = tab.dataset.tabIndex;

      //Move slider
      this.flicktySlider.select(currentIndex);

      //Set new style
      this.handleNewStyle(currentIndex);
    }

    handleNewStyle(index) {
      let tab = this.querySelector(`.image-with-tabs__tab[data-tab-index="${index}"]`);

  // Remove selected class from all tabs
  this.tabButtons.forEach((tab) => {
    tab.classList.remove('is-selected');
  });
  
  // Add selected and focused classes to the current tab
  tab.classList.add('is-selected');

      
      this.style.setProperty("--current-tab-text-color", tab.dataset.tabTextColor);
      this.style.setProperty("--current-tab-bg-color", tab.dataset.tabBackgroundColor);
    }
  }
  customElements.define('image-with-tabs', ImageWithtabs);
}